import { render } from "./OuterPasswordComplete.vue?vue&type=template&id=74e65d6b&scoped=true&ts=true"
import script from "./OuterPasswordComplete.vue?vue&type=script&lang=ts"
export * from "./OuterPasswordComplete.vue?vue&type=script&lang=ts"

import "./OuterPasswordComplete.vue?vue&type=style&index=0&id=74e65d6b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74e65d6b"]])

export default __exports__